import { z } from "zod";
import { zIsoDate, zId } from "./common.js";

export const GIFT_AID_DECLARATION_METHODS = ["written", "online", "verbal"] as const;
export const zGiftAidDeclarationMethod = z.enum(GIFT_AID_DECLARATION_METHODS);

export const zCreateGiftAidDeclaration = z.object({
  constituentId: zId,
  method: zGiftAidDeclarationMethod.default("written"),
  /** HMRC allows declarations to cover donations up to 4 years back */
  effectiveFrom: zIsoDate,
  notes: z.string().max(2000).optional(),
});
export type CreateGiftAidDeclaration = z.infer<typeof zCreateGiftAidDeclaration>;

export const GIFT_AID_CLAIM_STATUSES = ["draft", "submitted", "paid"] as const;
export const zGiftAidClaimStatus = z.enum(GIFT_AID_CLAIM_STATUSES);
export type GiftAidClaimStatus = z.infer<typeof zGiftAidClaimStatus>;

/** builds a claim from every eligible, unclaimed gift in the period */
export const zCreateGiftAidClaim = z.object({
  periodFrom: zIsoDate.optional(),
  periodTo: zIsoDate.optional(),
});
export type CreateGiftAidClaim = z.infer<typeof zCreateGiftAidClaim>;
